import { render, staticRenderFns } from "./SitemapItem.vue?vue&type=template&id=2522b79a&scoped=true&"
import script from "./SitemapItem.vue?vue&type=script&lang=ts&"
export * from "./SitemapItem.vue?vue&type=script&lang=ts&"
import style0 from "./SitemapItem.vue?vue&type=style&index=0&id=2522b79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2522b79a",
  null
  
)

export default component.exports